import { App } from "vue";
import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';

export default {
    install(app: App) {
        const plugins = {
            Flip: Flip
        };

        gsap.registerPlugin(Flip);

        app.config.globalProperties.$gsap = gsap;
        app.config.globalProperties.$gsapPlugins = plugins;

        app.provide('$gsap', gsap);
        app.provide('$gsapPlugins', plugins);
    },
};

declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
        $gsap: typeof gsap;
        $gsapPlugins: {
            Flip: typeof Flip;
        };
    }
}
